// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2w7uU","header":"styles_header__1R4_1","summary":"styles_summary__2u1oZ","detailsAssociations":"styles_detailsAssociations__lGIHz"};